// extracted by mini-css-extract-plugin
export var dropdown = "_vm-0";
export var imageWrapper = "_vm-3";
export var itemNameContainer = "_vm-1";
export var productImage = "_vm-2";
export var spinnerWrapper = "_vm-4";